import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { addCustomPathToLink, generateKey, getCurrentPathname, removeLastSlashes, removeFirstSlashes } from '../../functions';
import styles from './MainNavigation.module.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { GlobalContext } from '../../views/pages/GlobalContext';
import Logo from './Logo';
import HamburgerMenuItem from './HamburgerMenuItem';
import NavLinks from './NavLinks';
import HamburgerMenu from './HamburgerMenu';
import { DataContext } from '../../views/pages/Root';
import MenuTiles from '../MenuTiles/MenuTiles';

const MainNavigation = () => {
  const data = useContext(DataContext);
  // console.log('data:', data);
  const [menuItemsLoader, setMenuItemsLoader] = useState(true);
  const [prevPage, setPrevPage] = useState(null);
  const [nextPage, setNextPage] = useState(null);
  const [menuStructureHamburgerArray, setMenuStructureHamburgerArray] = useState(null);
  const [menuFlatStructure, setMenuFlatStructure] = useState(false);

  const { context, setContext } = useContext(GlobalContext);

  const location = useLocation();
  const currentPathname = getCurrentPathname(location);

  const getMenuStructure = (menuData) => {
    const menuStructureHamburger = [];
    const menuFlatStructure = [];
    let prevPage = null;
    let currentPage = null;
    let currentIter = 0;
    let currentPageIter = 0;
    let nextPage = null;

    const DFSAlgorithm = (array, key = generateKey()) => {
      if (array.length === 0) {
        return;
      }
      // console.log("menuStructureHamburger",menuStructureHamburger)

      const item = array.shift();
      if (!!item?.inmenu || !!item?.wraps) {
        menuStructureHamburger.push(<HamburgerMenuItem item={item} key={generateKey()} parentKey={key} />);
      }

      if (!!item?.slug) {
        menuFlatStructure.push(item);
        currentIter += 1;
        if (!!currentPage) {
          if (!nextPage) nextPage = item;
        } else {
          // console.log(item.slug, currentPathname);
          // console.log(removeLastSlashes(removeFirstSlashes(item.slug)), removeLastSlashes(currentPathname));
          if (
            removeLastSlashes(removeFirstSlashes(item.slug)) == removeLastSlashes(currentPathname) ||
            removeLastSlashes(item.slug) == removeLastSlashes(currentPathname)
          ) {
            // console.log('==');
            currentPage = item;
            currentPageIter = currentIter;
          } else {
            // console.log('!=');
            prevPage = item;
          }
        }
      }

      if (!!item?.wraps) {
        DFSAlgorithm(item?.wraps, key);
        key = generateKey();
      } else if (!!item?.subcategories) {
        DFSAlgorithm(item?.subcategories, key);
      }
      DFSAlgorithm(array, key);
    };

    DFSAlgorithm(menuData);
    // console.log("menuFlatStructure");
    // console.log(menuFlatStructure);
    // console.log("menuFlatStructure");

    return {
      menuStructureHamburger: menuStructureHamburger,
      menuFlatStructure: menuFlatStructure,
      prevPage: prevPage,
      nextPage: nextPage,
      currentIter: currentIter,
      currentPageIter: currentPageIter,
    };
  };

  useEffect((_) => {
    const menuStructureData = getMenuStructure(data.menu);
    // console.log('menuStructureData:', menuStructureData);
    setPrevPage(menuStructureData.currentPageIter == 0 ? null : menuStructureData.prevPage);
    setNextPage(
      menuStructureData.currentPageIter == 0 && !menuStructureData.nextPage ? menuStructureData.menuFlatStructure[0] : menuStructureData.nextPage
    );
    setMenuStructureHamburgerArray(menuStructureData.menuStructureHamburger);
    // console.log('setMenuStructureHamburgerArray', menuStructureData.menuStructureHamburger);
    setMenuFlatStructure(menuStructureData.menuFlatStructure);

    setContext({
      menuCurrentPage: menuStructureData.currentPageIter,
      menuFlatStructure: menuStructureData.menuFlatStructure,
      menuItemsNumber: menuStructureData.currentIter,
    });
    setMenuItemsLoader(false);
    // console.log(menuStructureData.currentPageIter, menuStructureData.prevPage, menuStructureData.nextPage);
  }, []);

  useEffect(
    (_) => {
      // console.log('----------------------');
      //  console.log('location', location);

      if (!!menuFlatStructure) {
        let currentPageIndex = menuFlatStructure.findIndex((menuItem) => {
          // console.log(
          //   'compare',
          //   menuItem.slug,
          //   currentPathname,
          //   removeLastSlashes(removeFirstSlashes(menuItem.slug)),
          //   removeLastSlashes(currentPathname)
          // );

          return (
            !!menuItem?.slug &&
            (removeLastSlashes(removeFirstSlashes(menuItem.slug)) == removeLastSlashes(currentPathname) ||
              removeLastSlashes(menuItem.slug) == removeLastSlashes(currentPathname))
          );
        });
        if (!currentPageIndex || currentPageIndex == -1) currentPageIndex = 0;
        //fixed - problem z linkiem w home page do menu 1 zamiast 0
        //FIXME: zmienić na obsługe wg root path?????
        // if (currentPathname == 'magazyn/ogrod-2024') currentPageIndex = -1;
        // if (currentPathname == 'magazyn/projekty-2024') currentPageIndex = -1;
        //  if (currentPathname == 'magazyn/ogrod-2025') currentPageIndex = -1;
        if (currentPathname == 'magazyn/projekty-2025') currentPageIndex = -1;
        setContext({
          ...context,
          menuCurrentPage: currentPageIndex + 1,
        });

        setPrevPage(currentPageIndex > 0 ? menuFlatStructure[currentPageIndex - 1] : null);
        setNextPage(currentPageIndex < menuFlatStructure.length - 1 ? menuFlatStructure[currentPageIndex + 1] : null);
      }
      // console.log('----------------------');
    },
    [location.pathname]
  );

  return (
    !menuItemsLoader && (
      <>
        {menuStructureHamburgerArray?.length > 1 && (!!prevPage || !!nextPage) && <NavLinks prevPage={prevPage} nextPage={nextPage} />}
        <div>
          <Logo />
          <HamburgerMenu menuArray={menuStructureHamburgerArray} />
        </div>
        <div className={styles.bgMenu}></div>
        <MenuTiles contextData={context} />
      </>
    )
  );
};

export default MainNavigation;
